<template>
    <footer class="website-footer">
        <div class="footer-box">
            <img :src="acemap" alt="">
            <span class="cu-span">Contact Us: robinlu1209@sjtu.edu.cn</span>
        </div>
        <p>© Copyright 2015-2023 Acemap, Inc. Shanghai Jiao Tong University.</p>
        <p>粤ICP备18023992号</p>
    </footer>
</template>
<script>
import acemap from '@/assets/acemap.svg'
export default {
    data() {
        return {
            acemap
        }
    }
}
</script>
<style lang="less">
    .website-footer {
         background: linear-gradient(116.69deg,#000 -86.16%,#00a2ff 56.2%);
        width: 100%;
        text-align: center;
        font-family: Source Han Sans SC;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        color: #fff;
        .footer-box {
            width: 100%;
            height: 64px;
            background: rgba(255, 255, 255, 0.42);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 8px;
        }
        .powerby {
            font-weight: 900;
            margin-right: 16px;
        }
        .cu-span{
            font-size: 12px;
            font-weight: bold;
            margin-left: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Footer/index.vue